import { useState, useEffect, useRef } from 'react';
import { useTranslation } from "react-i18next";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import findFaturamento from '../../service/findFaturamento';
import { SortOrder } from 'primereact/api';
import { Button } from 'primereact/button';
import postRelatorio from '../../service/postRelatorio';
import { FiltrarRelatorio } from '../../interface/FiltrarRelatorio';
import { Messages } from 'primereact/messages';
import putEstornarFaturamento from '../../service/putEstornarFaturamento';
import getResumoFaturamento from '../../service/getResumoFaturamento';
import patchGerarBoletoFaturamento from '../../service/patchGerarBoletoFaturamento';
import getZipNotaFiscalFaturamento from '../../service/getZipNotaFiscalFaturamento';
import getZipBoletoFaturamento from '../../service/getZipBoletoFaturamento';
import { useGlobalState } from '../../components/globalState/GlobalStateProvider';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { Nullable } from 'primereact/ts-helpers';
import { Toolbar } from 'primereact/toolbar';
import { Tag } from 'primereact/tag';
import { Dialog } from 'primereact/dialog';
import { Card } from 'primereact/card';
import { Menu } from 'primereact/menu';



export default function FaturamentoList() {
  const { t } = useTranslation();
  const [faturamentos, setFaturamentos] = useState(undefined);
  const [totalRecords, setTotalRecords] = useState(0);
  const { state } = useGlobalState();
  const msgs = useRef<Messages>(null);
  const menuAcoes = useRef<Menu>(null);
  const [menuItems, setMenuItems] = useState<any[]>([]);
  const [dataReferencia, setDataReferencia] = useState<Nullable<Date | null>>(null);
  const [status, setStatus] = useState<Nullable<String | null>>(null);
  const [resumoVisible, setResumoVisible] = useState(false);
  const [resumoData, setResumoData] = useState<any[]>([]);
  const [estornoVisible, setEstornoVisible] = useState(false);
  const [estornoItem, setEstornoItem] = useState<any>(null);
  const [boletoVisible, setBoletoVisible] = useState(false);
  const [boletoItem, setBoletoItem] = useState<any>(null);

  const statusList = [
    { label: 'Incluído', value: 'INCLUIDO' },
    { label: 'Processado', value: 'PROCESSADO' },
    { label: 'Processando', value: 'PROCESSANDO' },
    { label: 'Estornando', value: 'ESTORNANDO' },
    { label: 'Erro', value: 'ERRO' }
  ]

  const [lazyState, setlazyState] = useState({
    first: 0,
    rows: 10,
    page: 1,
    data: dataReferencia,
    status: status,
    sortField: 'dataReferencia',
    sortOrder: SortOrder.DESC
  });

  const onPage = (event: any) => {
    setlazyState({
      first: event.first,
      rows: event.rows,
      page: (event.first / event.rows) + 1,
      data: dataReferencia,
      status: status,
      sortField: event.sortField,
      sortOrder: event.sortOrder
    });
  };
  const onSort = (event: any) => {
    setlazyState({
      first: 0,
      rows: 10,
      page: 1,
      data: dataReferencia,
      status: status,
      sortField: event.sortField,
      sortOrder: event.sortOrder
    });
  };

  const formatDate = (value: { toLocaleDateString: (arg0: string, arg1: { day: string; month: string; year: string; }) => any; }) => {
    return value.toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  };

  const imprimirInconsistencia = (item: any) => {
    const filtrarRelatorio: FiltrarRelatorio = { tipoRelatorio: 'FATURAMENTO_INCONSISTENCIA', tipoArquivo: 'PDF', filtro: { id: item.id } };
    postRelatorio(filtrarRelatorio).then((data) => {
      if (msgs.current) {
        msgs.current?.clear();
        msgs.current?.show([
          { sticky: false, life: 10000, severity: 'info', summary: 'Sucesso', detail: data, closable: false }

        ]);
      }
    });
  }

  const imprimirEspelho = (item: any) => {
    const filtrarRelatorio: FiltrarRelatorio = { tipoRelatorio: 'FATURAMENTO_ESPELHO', tipoArquivo: 'CSV', filtro: { id: item.id } };
    postRelatorio(filtrarRelatorio).then((data) => {
      if (msgs.current) {
        msgs.current?.clear();
        msgs.current?.show([
          { sticky: false, life: 10000, severity: 'info', summary: 'Sucesso', detail: data, closable: false }

        ]);
      }
    });
  }

  const confirmarEstorno = (item: any) => {
    setEstornoItem(item);
    setEstornoVisible(true);
  }

  const estornar = () => {
    if (!estornoItem) return;
    setEstornoVisible(false);
    putEstornarFaturamento(estornoItem).then((data) => {
      if (msgs.current) {
        msgs.current?.clear();
        msgs.current?.show([
          { sticky: false, life: 10000, severity: 'info', summary: 'Sucesso', detail: data, closable: false }
        ]);
      }
      setEstornoItem(null);
      loadLazyData();
    });
  }

  const abrirResumo = (item: any) => {
    getResumoFaturamento(item.id).then((data) => {
      setResumoData(data);
      setResumoVisible(true);
    }).catch(() => {
      if (msgs.current) {
        msgs.current?.clear();
        msgs.current?.show([
          { sticky: false, life: 10000, severity: 'error', summary: 'Erro', detail: 'Erro ao buscar resumo do faturamento', closable: false }
        ]);
      }
    });
  }

  const confirmarGerarBoleto = (item: any) => {
    setBoletoItem(item);
    setBoletoVisible(true);
  }

  const gerarBoleto = () => {
    if (!boletoItem) return;
    setBoletoVisible(false);
    patchGerarBoletoFaturamento(boletoItem.id).then(() => {
      if (msgs.current) {
        msgs.current?.clear();
        msgs.current?.show([
          { sticky: false, life: 10000, severity: 'info', summary: 'Sucesso', detail: 'Geração de boletos em andamento', closable: false }
        ]);
      }
      setBoletoItem(null);
      loadLazyData();
    }).catch(() => {
      if (msgs.current) {
        msgs.current?.clear();
        msgs.current?.show([
          { sticky: false, life: 10000, severity: 'error', summary: 'Erro', detail: 'Erro ao gerar boletos', closable: false }
        ]);
      }
    });
  }

  const baixarArquivo = (blobFile: Blob, nomeArquivo: string) => {
    const url = window.URL.createObjectURL(new Blob([blobFile], { type: 'application/zip' }));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', nomeArquivo);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  }

  const baixarZipNotaFiscal = (item: any) => {
    getZipNotaFiscalFaturamento(item.id).then((blobFile: Blob) => {
      baixarArquivo(blobFile, `notas-fiscais-${item.id}.zip`);
    }).catch(() => {
      if (msgs.current) {
        msgs.current?.clear();
        msgs.current?.show([
          { sticky: false, life: 10000, severity: 'error', summary: 'Erro', detail: 'Erro ao baixar ZIP das notas fiscais', closable: false }
        ]);
      }
    });
  }

  const baixarZipBoleto = (item: any) => {
    getZipBoletoFaturamento(item.id).then((blobFile: Blob) => {
      baixarArquivo(blobFile, `boletos-${item.id}.zip`);
    }).catch(() => {
      if (msgs.current) {
        msgs.current?.clear();
        msgs.current?.show([
          { sticky: false, life: 10000, severity: 'error', summary: 'Erro', detail: 'Erro ao baixar ZIP dos boletos', closable: false }
        ]);
      }
    });
  }

  const buildAcoesFaturamento = (item: any) => {
    const items: any[] = [];

    if (item.status === 'PROCESSADO' || item.status === 'ENVIADO') {
      items.push({
        label: 'Imprimir Espelho',
        icon: 'pi pi-print',
        command: () => imprimirEspelho(item),
      });
    }

    if (item.status === 'PROCESSADO' || item.status === 'ENVIADO') {
      items.push({
        label: 'Imprimir Inconsistência',
        icon: 'pi pi-ban',
        command: () => imprimirInconsistencia(item),
      });
    }

    if (item.status === 'PROCESSADO') {
      items.push({
        label: 'Estornar',
        icon: 'pi pi-trash',
        command: () => confirmarEstorno(item),
      });
    }

    if (item.status === 'PROCESSADO' || item.status === 'ENVIADO') {
      items.push({
        label: 'Resumo',
        icon: 'pi pi-chart-bar',
        command: () => abrirResumo(item),
      });
    }

    if (item.status === 'PROCESSADO' && state.user?.funcoes?.includes('FATURAMENTO_BOLETO')) {
      items.push({
        label: 'Gerar Boletos',
        icon: 'pi pi-file',
        command: () => confirmarGerarBoleto(item),
      });
    }

    if (item.status === 'ENVIADO' && state.user?.funcoes?.includes('FATURAMENTO_ZIP_NOTA_FISCAL')) {
      items.push({
        label: 'Baixar ZIP Notas Fiscais',
        icon: 'pi pi-file-pdf',
        command: () => baixarZipNotaFiscal(item),
      });
    }

    if (item.status === 'ENVIADO' && state.user?.funcoes?.includes('FATURAMENTO_ZIP_BOLETO')) {
      items.push({
        label: 'Baixar ZIP Boletos',
        icon: 'pi pi-money-bill',
        command: () => baixarZipBoleto(item),
      });
    }

    return items;
  }

  const actionTemplate = (item: any) => {
    const acoes = buildAcoesFaturamento(item);
    if (acoes.length === 0) {
      return null;
    }

    return (
      <Button
        icon="pi pi-ellipsis-v"
        tooltip="Ações"
        aria-label="Ações"
        onClick={(e) => {
          setMenuItems(acoes);
          menuAcoes.current?.toggle(e);
        }}
        style={{
          background: 'transparent',
          color: 'gray',
          border: 'none',
        }}
      />
    );
  }

  const dateBodyTemplate = (date: Nullable<Date>, hour:boolean) => {
    if (date) {
      return new Intl.DateTimeFormat('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: hour ? '2-digit' : undefined,
        minute: hour ? '2-digit' : undefined
      }).format(new Date(date));
    }

    return '';
  };

  const loadLazyData = () => {
    findFaturamento(lazyState).then(data => { setTotalRecords(data.total); setFaturamentos(data.faturamentos) }).catch(() => { setTotalRecords(0); setFaturamentos(undefined) });
  }

  const changeStatus = (stat: Nullable<String>) => {
    if (stat) {
      setStatus(stat);
      setlazyState({
        first: 0,
        rows: 10,
        page: 1,
        data: dataReferencia,
        status: stat,
        sortField: 'dataReferencia',
        sortOrder: SortOrder.DESC
      });
    }
  }

  const statusTemplate = (rowData: any) => {
    return (
      <Tag
        value={getStatusLabel(rowData.status)}
        severity={getStatusSeverity(rowData.status) as any}
      />
    );
  };
  const getStatusSeverity = (status: string) => {
    switch (status) {
      case 'PROCESSADO': return 'success';
      case 'INCLUIDO': return 'secondary';
      case 'PROCESSANDO': return 'info';
      default: return 'info';
    }
  };

  const getStatusLabel = (status: string) => {
    const labels: { [key: string]: string } = {
      'PROCESSADO': 'Processado',
      'INCLUIDO': 'Incluído',
      'PROCESSANDO': 'Processando'
    };
    return labels[status] || status;
  };

  const changeData = (dataRef: Nullable<Date>) => {
    if (dataRef) {
      setDataReferencia(dataRef);
      setlazyState({
        first: 0,
        rows: 10,
        page: 1,
        data: dataRef,
        status: status,
        sortField: 'dataReferencia',
        sortOrder: SortOrder.DESC
      });
    }
  }

  const startContent = (
    <div className="filtros">
      <div className="filtros-grid">
        <div className="filtros-item">
          <label htmlFor="data" className="font-bold">{t('dataReferencia')}</label>
          <Calendar
            id="data"
            value={dataReferencia}
            onChange={(e) => changeData(e.value)}
            showIcon
            dateFormat="mm/yy"
            locale="pt"
          />
        </div>
        {!state.user.cliente && (
          <div className="filtros-item">
            <label htmlFor="status" className="font-bold">{t("status")}</label>
            <Dropdown inputId="status" value={status} onChange={(e) => { changeStatus(e.value) }} options={statusList} optionLabel="label" placeholder="Selecione Status" showClear filter />
          </div>
        )}
      </div>
    </div>
  );

  useEffect(() => {
    loadLazyData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lazyState])

  return (
    <div>
      <Messages ref={msgs} />
      <Menu model={menuItems} popup ref={menuAcoes} />
      <Dialog header="Confirmação de Estorno" visible={estornoVisible} style={{ width: '30vw' }} onHide={() => setEstornoVisible(false)}
        footer={
          <div>
            <Button label="Cancelar" icon="pi pi-times" onClick={() => setEstornoVisible(false)} className="p-button-text" />
            <Button label="Confirmar Estorno" icon="pi pi-check" onClick={estornar} className="p-button-danger" />
          </div>
        }>
        {estornoItem && (
          <div>
            <p style={{ marginBottom: '0.5rem' }}><strong>Tem certeza que deseja estornar este faturamento?</strong></p>
            <p><strong>{t('dataReferencia')}:</strong> {formatDate(estornoItem.dataReferencia)}</p>
            <p><strong>{t('dataInicio')}:</strong> {formatDate(estornoItem.dataInicio)}</p>
            <p><strong>{t('dataFim')}:</strong> {formatDate(estornoItem.dataFim)}</p>
          </div>
        )}
      </Dialog>
      <Dialog header="Confirmação de Geração de Boletos" visible={boletoVisible} style={{ width: '30vw' }} onHide={() => setBoletoVisible(false)}
        footer={
          <div>
            <Button label="Cancelar" icon="pi pi-times" onClick={() => setBoletoVisible(false)} className="p-button-text" />
            <Button label="Confirmar" icon="pi pi-check" onClick={gerarBoleto} />
          </div>
        }>
        {boletoItem && (
          <div>
            <p style={{ marginBottom: '0.5rem' }}><strong>Tem certeza que deseja gerar as notas e boletos deste faturamento?</strong></p>
            <p><strong>{t('dataReferencia')}:</strong> {formatDate(boletoItem.dataReferencia)}</p>
            <p><strong>{t('dataInicio')}:</strong> {formatDate(boletoItem.dataInicio)}</p>
            <p><strong>{t('dataFim')}:</strong> {formatDate(boletoItem.dataFim)}</p>
          </div>
        )}
      </Dialog>
      <Dialog header="Resumo do Faturamento" visible={resumoVisible} style={{ width: '70vw' }} onHide={() => setResumoVisible(false)}>
        <div className="flex-consulta  flex-wrap gap-3">
          {resumoData.map((item: any, index: number) => (
            <Card className='flex-1' style={{ backgroundColor: '#e6ffe6' }} key={index}>
              <div className="flex-consulta  justify-content-between gap-5">
                <div className="flex-consulta  flex-column gap-1">
                  <span style={{ color: '#008000' }} className=" text-sm">{item.label}</span>
                  <span style={{ color: '#008000' }} className="font-bold text-lg">{item.value}</span>
                </div>
                <span className="w-2rem h-2rem border-circle inline-flex justify-content-center align-items-center text-center" style={{ backgroundColor: '#008000', color: 'white' }}>
                  <i className={'pi ' + item.icon} />
                </span>
              </div>
            </Card>
          ))}
        </div>
      </Dialog>
      <div>
        <Toolbar start={startContent} />
        <br></br>
        <br></br>
        <DataTable value={faturamentos} first={lazyState.first} dataKey="id" paginator={true} lazy={true}
          emptyMessage="Sem registros"
          onSort={onSort} sortField={lazyState.sortField} sortOrder={lazyState.sortOrder}
          rows={lazyState.rows} totalRecords={totalRecords} onPage={onPage}
          tableStyle={{ minWidth: '75rem' }}>
          <Column body={(e) => dateBodyTemplate(e.dataInclusao, true)} header={t('dataInclusao')} />
          <Column field='usuario' header={t('usuario')} />
          <Column field='status' header={t('status')} body={statusTemplate} />
          <Column body={(e) => dateBodyTemplate(e.dataReferencia, false)} header={t('dataReferencia')} />
          <Column body={(e) => dateBodyTemplate(e.dataVencimento, false)} header={t('dataVencimento')} />
          <Column body={(e) => dateBodyTemplate(e.dataInicio, false)} header={t('dataInicio')} />
          <Column body={(e) => dateBodyTemplate(e.dataFim, false)} header={t('dataFim')} />
         
          <Column body={actionTemplate} />
        </DataTable>
      </div>
    </div>
  )
}


